import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import PageBanner from "../Components/PageBanner";
import NewsCard from "../Components/NewsCard";
import { newsData as initialNewsData } from "../Constants/Data";

export default function News() {
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    setNewsData(initialNewsData);
  }, []);

  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(newsData.length / itemsPerPage);

  const paginatedNews = newsData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Blogs | Urban View Real Estate PVT LTD</title>
        <meta
          name="description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="keywords"
          content="Affordable Homes for Sale in South Australia, Affordable Homes for Sale in Melbourne, Affordable Homes for Sale in Queensland, Development Sites for Sale in Sydney, Cheap Rent a Home in Penrith, House Buying in Western Australia, Cheap Duplex Home in Tamworth, Affordable duplex Home in Armidale, Houses for Rental in St Marys, Investement Property in Queensland, Best Investment Property Sale in Brisbane, Best Investment Property Sale in Rouse Hill, Box Hill, Marsden Park, Vineyard, Investment Property Buy in Austral, Investment Property Buy in Tallawong, Investment Property Buy in Oran Park, Investment Property Buy in Leppington"
        />

        <meta name="author" content="Urban View Real Estate PVT LTD" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://urbanviewre.com/news" />

        {/* Open Graph */}
        <meta property="og:title" content="Urban View Real Estate PVT LTD" />
        <meta
          property="og:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta property="og:site_name" content="Urban View Real Estate" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://urbanviewre.com" />
        <meta
          property="og:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="twitter:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta
          name="twitter:image"
          content="https://urbanviewre.com/assets/logo-2-CGgGTWZk.png"
        />
        <meta name="twitter:site" content="@urbanviewre" />
        <meta name="twitter:creator" content="@urbanviewre" />

        {/* Facebook  */}
        <meta
          property="fb:admins"
          content="https://www.facebook.com/profile.php?id=61559035348971"
        />

        {/* Instagram */}
        <meta name="instagram:title" content="Urban View Real Estate PVT LTD" />
        <meta
          name="instagram:description"
          content="Find affordable homes for sale & rent across Australia with Urban View Real Estate. Explore investment properties in Brisbane, Sydney suburbs, Queensland & Melbourne."
        />
        <meta name="instagram:site" content="@urbanviewrealestate" />
      </Helmet>

      <PageBanner
        title="Blogs"
        breadcrumbs={[
          { label: "Home", href: "/", icon: "bi-house-door-fill" },
          { label: "Blogs", active: true },
        ]}
      />

      <section className="py-5 mb-5 text-center">
        <div className="container">
          <h6 className="badge text-primary rounded-4 fw-bold px-3 fs-6">
            News & Blogs
          </h6>
          <h2 className="fw-bold brand py-3">Latest News Feeds</h2>

          <div className="row mt-4">
            {paginatedNews.map((news) => (
              <div className="col-md-4 mb-4" key={news.id}>
                <NewsCard
                  image={news.image}
                  title={news.title}
                  author={news.author}
                  category={news.category}
                  date={news.date}
                  link={news.link}
                />
              </div>
            ))}
          </div>

          <div className="py-5 d-flex justify-content-center">
            <button
              className="btn btn-primary mx-2 rounded-0"
              disabled={currentPage === 1}
              onClick={() => goToPage(currentPage - 1)}
            >
              <i className="bi bi-chevron-left"></i>{" "}
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                className={`btn rounded-0 mx-1 ${
                  currentPage === index + 1
                    ? "btn-light border-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => goToPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              className="btn btn-primary mx-2 rounded-0"
              disabled={currentPage === totalPages}
              onClick={() => goToPage(currentPage + 1)}
            >
              <i className="bi bi-chevron-right"></i>{" "}
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
